import { Location } from 'history'
import { Article } from '../Articles'
import { useLocation } from 'react-router'
import { Form, Formik, Field } from 'formik'
import { isDark } from '../../../../../utils'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useTw } from '../../../../../utils/Styles'
import { useArticlesQuery } from './Articles.generated'
import { useProfile } from '../../../../../utils/Profile'
import { ChevronRightIcon } from '@heroicons/react/outline'
import { SubmitListener } from '../../../../../utils/SubmitListener'
import Wrapper, { LoadingSpinner } from '../../../../../utils/Wrapper'

export function SearchArticles() {
  const tw = useTw()
  const profile = useProfile()
  const navigate = useNavigate()
  const [t] = useTranslation('common')
  const { state } = useLocation() as Location<{ search: string }>
  const articles = useArticlesQuery({ variables: { search: state.search } })

  return (
    <Wrapper
      title={t('knowledge_base.title')}
      subtitle={t('knowledge_base.articles.search_subtitle')}
    >
      <Formik
        enableReinitialize
        initialValues={{ search: state.search }}
        onSubmit={(values) =>
          values.search &&
          navigate('/kb-search', { state: { search: values.search } })
        }
      >
        <Form className={tw`flex px-4 mt-4 h-14`}>
          <Field
            name="search"
            type="text"
            placeholder={t('home.kb.search_placeholder')}
            className={tw`select-none my-2 w-full rounded-l border-r-0 focus:ring-foreground focus:border-foreground outline-none`}
          />
          <button
            type="submit"
            className={tw`leading-6 px-2 my-2 bg-foreground rounded-r`}
          >
            <ChevronRightIcon
              className={tw`h-6 w-6
                ${isDark(profile.foreground) ? 'text-white' : 'text-black'}
              `}
            />
          </button>
          <SubmitListener />
        </Form>
      </Formik>

      {articles.loading ? (
        <div className={tw`w-full h-10`}>
          <LoadingSpinner />
        </div>
      ) : articles.data?.Profile?.knowledgeBase?.articles?.length ? (
        <div className={tw`my-4 space-y-4 px-4`}>
          {articles.data?.Profile?.knowledgeBase?.articles.map((article) => (
            <Article key={article._id} article={article} />
          ))}
        </div>
      ) : (
        <div className={tw`w-full mt-1.5`}>
          <p className={tw`text-neutral-350 text-center`}>
            {t('knowledge_base.search.not_found')}
          </p>
        </div>
      )}
    </Wrapper>
  )
}
